import { gql } from "apollo-boost";

const volunteers = gql`
  query volunteers($filter: VolunteerFilter!) {
    volunteers(filter: $filter) {
      total
      items {
        id
        title
        schedule
        createdAt
        updatedAt
        duration
        hours
        deadline
        maxHours
        canEdit
        status
        needConfirmation
        stats {
          count
          confirmed
          hours
        }
      }
    }
  }
`;

const volunteer = gql`
  query volunteer($id: String!) {
    volunteer(id: $id) {
      id
      version
      title
      description
      participationDetail
      requirements
      schedule
      deadline
      maxHours
      canEdit
      status
      categories
      manager
      location {
        addr
        placeId
        displayAddress
      }
      recipients {
        community {
          id
          name
        }
      }
      host {
        name
        website
        contact
        email
        phone
        other
      }
      pic {
        imageUrl
        imageWidth
        imageHeight
        imageSize
      }
      questions
      options {
        name
        startTime
        endTime
        max
      }
      createdAt
      needConfirmation
      customizedChoice
    }
  }
`;

const exportVolunteer = gql`
  query exportVolunteer($id: String!) {
    exportVolunteer(id: $id) {
      filename
      data
    }
  }
`;
const createVolunteer = gql`
  mutation createVolunteer($input: CreateVolunteerInput!) {
    createVolunteer(input: $input) {
      code
      msg
    }
  }
`;

const cancelVolunteer = gql`
  mutation cancelVolunteer($activityId: String!, $date: [String!]!) {
    cancelVolunteer(activityId: $activityId, date: $date)
  }
`;

const volunteerHistory = gql`
  query volunteerHistory($filter: VolunteerHistoryFilter!) {
    volunteerHistory(filter: $filter) {
      total
      items {
        id
        title
        duration
        time
        participants
        status
      }
    }
  }
`;
const volunteerApplications = gql`
  query volunteerApplications($id: String!) {
    volunteerApplications(id: $id) {
      id
      children {
        id
        name
      }
      parent {
        id
        name
      }
      status
      comments
      schedule
      options {
        startTime
        endTime
      }
      others {
        name
        email
      }
      chaperone
      myself
      participants
      servingHours
      deadline
      maxHours
      qa {
        question
        answer
      }
      createdAt
    }
  }
`;

const confirmVolunteerApplication = gql`
  mutation confirmVolunteerApplication($applicationId: String!, $confirmed: Boolean!) {
    confirmVolunteerApplication(applicationId: $applicationId, confirmed: $confirmed)
  }
`;

const setVolunteerStatus = gql`
  mutation setVolunteerStatus($activityId: String!, $pause: Boolean!) {
    setVolunteerStatus(activityId: $activityId, pause: $pause)
  }
`;

const volunteerEmail2Host = gql`
  mutation volunteerEmail2Host($id: String!) {
    volunteerEmail2Host(id: $id)
  }
`;

export const volunteerGql = {
  volunteers,
  volunteer,
  cancelVolunteer,
  exportVolunteer,
  createVolunteer,
  volunteerApplications,
  confirmVolunteerApplication,
  setVolunteerStatus,
  volunteerEmail2Host,
  volunteerHistory,
};
